const DEFAULT_MONTH = 0 // January
const DEFAULT_DAY = 1

export const isDateRange = (date) => date.includes('/')

export const isApproximateDate = (date) => date.startsWith('A')

const scrub = (date) => {
  return date.replace('+', '').replace('A', '').trim()
}

const numberize = (datePart) => (datePart ? Number.parseInt(datePart, 10) : undefined)

export const getFirstFoundDateFromRange = (date) => {
  if (isDateRange(date)) {
    const parts = date.split('/')
    const listOfDates = [parts[0], parts[1]]
    const firstNotNullDate = listOfDates.find((item) => !!item)
    return firstNotNullDate
  }

  return date
}

export const compareYears = (a, b) => {
  // We don't use numberize here because it fails for input 0 (!!0 == false)
  const yearA = Number.parseInt(a, 10)
  const yearB = Number.parseInt(b, 10)

  // Follows https://www.ecma-international.org/ecma-262/10.0/index.html#sec-sortcompare
  if (Number.isNaN(yearA) && Number.isNaN(yearB)) {
    // a and b can't be compared, so we "fail" by treating them as equal
    return 0
  }

  // Note that (NaN < n) and (NaN > n) are both false

  if (Number.isNaN(yearA) || yearA > yearB) {
    return 1
  }

  if (Number.isNaN(yearB) || yearA < yearB) {
    return -1
  }

  return 0
}

export const getYearsDiffDates = (a, b) => {
  if (!a || !b || Number.isNaN(a.getTime()) || Number.isNaN(b.getTime())) {
    return null
  }
  // epoch millis / (sec * min * hours in day * days in year)
  return Math.floor((b.getTime() - a.getTime()) / (1000 * 3600 * 24 * 365.25))
}

export const getDatePartsWithDefaults = (date) => {
  if (!date) {
    throw new Error('Please provide a date.')
  }

  let newDate = date

  if (isDateRange(date)) {
    newDate = getFirstFoundDateFromRange(date)
  }

  newDate = scrub(newDate)

  const parts = newDate.split('-')
  return {
    year: numberize(parts[0]) || null,
    month: numberize(parts[1]) - 1 || DEFAULT_MONTH,
    day: numberize(parts[2]) || DEFAULT_DAY,
  }
}

export const extractFourDigitYear = (birthDate, defaultYear = 1970) => {
  let returnYear = defaultYear
  const dBirth = new Date(birthDate)

  if (!Number.isNaN(birthDate) && birthDate > 999 && birthDate < 9999) {
    return Number(birthDate)
  }
  if (birthDate === null || undefined) {
    return defaultYear
  }
  if (dBirth.getUTCFullYear()) {
    returnYear = dBirth.getUTCFullYear()
  } else {
    const regEx = /(1[0-9]{3}|20[0-4][0-9]|2050)/g
    const birthYearRegExResult = birthDate ? birthDate.match(regEx) : null
    if (birthYearRegExResult) {
      returnYear = birthYearRegExResult[0]
    }
  }

  return Number.parseInt(returnYear, 10)
}

export const getChurchStandardDateFormatWithParts = ({ year, month, day }) => {
  const actualDate = new Date(year, month, day)
  const dateFormatOptions = { month: 'short' }
  const shortMonthName = actualDate.toLocaleString('en-us', dateFormatOptions)
  const formattedDate = `${year} ${shortMonthName} ${day}`
  return formattedDate
}

export const getChurchStandardDateFormat = (date) => {
  const newDate = getDatePartsWithDefaults(date)

  return getChurchStandardDateFormatWithParts({ year: newDate.year, month: newDate.month, day: newDate.day })
}
